import React from 'react';

interface CouponDisplayProps {
  couponCode: string;
  couponDescription?: string;
}

const CouponDisplay: React.FC<CouponDisplayProps> = ({
  couponCode,
  couponDescription,
}) => (
  <div
    data-testid="coupon-display"
    className="small-6 large-3 m-coupon-display"
  >
    <div>
      Coupon Code:
      <span className="coupon-code" data-testid="coupon-code">
        {couponCode}
      </span>
    </div>
    {couponDescription && (
      <div data-testid="coupon-description">{couponDescription}</div>
    )}
  </div>
);

export default CouponDisplay;
